import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import { useDispatch } from 'react-redux';
import { getTodayRefundReceiptAndTotalPrice } from 'src/store/slices/generalMonitoringSlice';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import { ChartSkeleton, HeroStat, MonitorCard, formatCurrency, formatNumber, useCountUp } from 'src/components/monitoring/MonitoringParts';

// Bugün para iadesi yapılan fiş adedi ve toplam tutar
function TodayRefundTotalPriceChart() {
  const dispatch = useDispatch();
  const [mainData, setMainData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    setLoading(true);
    dispatch(getTodayRefundReceiptAndTotalPrice())
      .then((response) => {
        setMainData(Array.isArray(response.payload) ? response.payload : []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const row = mainData?.[0] || {};
  const count = Number(row.TotalFisNoCount) || 0;
  const amount = Number(row.TotalParaIadesiTutar) || 0;
  const countAnim = useCountUp(loading ? 0 : count);
  const amountAnim = useCountUp(loading ? 0 : amount);

  return (
    <MonitorCard title="Bugünkü Para İadeleri" subtitle="Bugün para iadesi yapılan fişler">
      {loading ? (
        <ChartSkeleton height={130} />
      ) : (
        <Grid container spacing={1.5}>
          <Grid item xs={12} sm={6}>
            <HeroStat icon={<ReceiptLongIcon />} label="İade edilen fiş" value={formatNumber(Math.round(countAnim))} footer="Bugün para iadesi yapılan" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <HeroStat
              icon={<PaymentsOutlinedIcon />}
              label="Toplam iade tutarı"
              value={formatCurrency(amountAnim)}
              footer={<>Fiş başına ortalama <b>{count > 0 ? formatCurrency(amount / count) : '-'}</b></>}
            />
          </Grid>
        </Grid>
      )}
    </MonitorCard>
  );
}

export default TodayRefundTotalPriceChart;
